// extracted by mini-css-extract-plugin
export default {"game_actions":"GameActions_game_actions__Vr2qm","side_actions":"GameActions_side_actions__Kwkda"};